import React, { useRef, useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  ClickAwayListener,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@material-ui/core";
import { Search, Info } from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete"
import sii from "../../../../data/sii"
import { storeNewCategories } from "../../../../data/categories"
import { AVAILABLE_DTE } from "../../../../data/avaiableDte";
import { AVERAGE_PRODUCTS } from "../../../../data/averageProducts";
import PERU_REGIONS from "../../../../data/peruRegions.json";
import { 
  CHILE,
  SHOP_FORM_SECTION_NAME,
  TOOLTIP_AVERAGE_PRODUCTS,
  ASEP_OPTION_NAME,
  YES_ASEP_ID,
  NO_ASEP_ID,
  TOOLTIP_OWN_FLEET,
  OWN_FLEET_OPTION_NAME,
  YES_OWN_FLEET_ID,
  NO_OWN_FLEET_ID,
  NO_RESTRICTION_DEPARTMENTS,
  DIALOG_STATE_INIT
} from "../../../../constants"
import CountryDocNumberFormatter from "../../../../utils/formatter/CountryDocNumberFormatter";
import { ShopFormJss } from "./styleJss"
import BusinessNameFormatter from '../../../../utils/formatter/BusinessNameFormatter';
import { ConfirmationDialog as Dialog } from "../../../common/components/Dialog";

const ShopForm = ({ stateProps }) => {
  const classes = ShopFormJss()
  const inputLabel = useRef(null)
  const [labelWidth, setLabelWidth] = useState(0)
  const [dialogState, setDialogState] = useState(DIALOG_STATE_INIT)
  const handleSetDialogState = () => setDialogState(DIALOG_STATE_INIT)
  useEffect(() => setLabelWidth(inputLabel.current.offsetWidth), [])
  const handleInputChange = (fieldName) => (event) => {
    if(fieldName==='department' && NO_RESTRICTION_DEPARTMENTS.includes(event.target.value)){
      stateProps.handleSetState(OWN_FLEET_OPTION_NAME ,SHOP_FORM_SECTION_NAME)(true)
    }
    stateProps.handleSetState(fieldName,SHOP_FORM_SECTION_NAME)(event.target.value)
  }

  const formatters={
    'commercial_name': BusinessNameFormatter.format,
    'business_name': BusinessNameFormatter.format,
    'id_social_reason': CountryDocNumberFormatter.format(stateProps.state.country)
  }

  const handleInputChangeWithFormat = (fieldName) => (event) => {
    const formatter=formatters[fieldName]
    const newValue=formatter(event.target.value)
    stateProps.handleSetState(fieldName, SHOP_FORM_SECTION_NAME)(newValue)
  };

  const handleClickAway = (fieldName) => (event) => {
    if (stateProps.state[fieldName] === '') {
      stateProps.onRestoreErrors(SHOP_FORM_SECTION_NAME, fieldName);
    }
  };

  const [checksStatus, setChecksStatus] = useState({
    [YES_ASEP_ID]: false,
    [NO_ASEP_ID]: false,
    [YES_OWN_FLEET_ID]: false,
    [NO_OWN_FLEET_ID]: false,
  });

  const handleRadioButton = (event) => {
    let selectedOptionValue = event.target.value === 'true';
    const selectedOptionName = event.target.name;
    const selectedOptionId = event.target.id;
    const newChecksStatus = {...checksStatus};
    if(selectedOptionName === ASEP_OPTION_NAME){
      newChecksStatus[YES_ASEP_ID] = selectedOptionId === YES_ASEP_ID;
      newChecksStatus[NO_ASEP_ID] = selectedOptionId === NO_ASEP_ID;
    }else{
      newChecksStatus[YES_OWN_FLEET_ID] = selectedOptionId === YES_OWN_FLEET_ID;
      newChecksStatus[NO_OWN_FLEET_ID] = selectedOptionId === NO_OWN_FLEET_ID;
      selectedOptionValue = newChecksStatus[NO_OWN_FLEET_ID] ? null : selectedOptionValue
      setDialogState(selectedOptionValue? DIALOG_STATE_INIT:{
        type: 'primary',
        title: <span className={classes.titleModal}>Mensaje informativo</span>,
        divider: true,
        noButton: false,
        open: true,
        buttonLabels: {
          onSuccessLabel: 'Aceptar'
        },
        actions: {
          onClose: handleSetDialogState,
          onSuccess: handleSetDialogState
        },
        children: (
          <Grid className={classes.insideModal}>
            <p>Lamentablemente no podrás seguir con el proceso de postulación al marketplace de Ripley.com debido a tu ubicación y no contar con flota propia para el despacho de tus productos.</p>
            <img
              src={window.location.origin + '/onboarding/osito_astronauta_triste.png'}
              alt="Osito Astronauta Triste"
            />
          </Grid>
        ),
      })
    }
    stateProps.handleSetState(selectedOptionName ,SHOP_FORM_SECTION_NAME)(selectedOptionValue);
    setChecksStatus(newChecksStatus);
  }

  return (
    <Grid
      item
      container
      direction="row"
      className={classes.buttonGrid}
    >
      <Grid item xs={12} className={classes.formGridTitle}>
        Datos de la tienda
      </Grid>
      <Grid item xs={12} md={6} className={classes.formGrid}>
        <ClickAwayListener onClickAway={handleClickAway("id_social_reason")}>
          <TextField className={classes.textFieldInput}
            required
            id="id_social_reason-required"
            label={
              stateProps.state.country === CHILE.value
                ? "RUT de la razón social"
                : "RUC de tu empresa"
            }
            variant="outlined"
            size="small"
            value={stateProps.state.id_social_reason}
            onChange={ e => {
              e.target.value = (e.target.value).toString().slice(0,12)
              handleInputChangeWithFormat("id_social_reason")(e)
            }}
            error={stateProps.errors.id_social_reason !== ""}
            helperText={stateProps.errors.id_social_reason}
            fullWidth
          />
        </ClickAwayListener>
      </Grid>
      <Grid item xs={12} md={6} className={classes.formGrid}>
        <ClickAwayListener onClickAway={handleClickAway("commercial_name")}>
          <TextField className={classes.textFieldInput}
            required
            id="commercial_name-required"
            label="Nombre comercial"
            variant="outlined"
            size="small"
            value={stateProps.state.commercial_name}
            onChange={handleInputChangeWithFormat("commercial_name")}
            error={stateProps.errors.commercial_name !== ""}
            helperText={stateProps.errors.commercial_name}
            fullWidth
          />
        </ClickAwayListener>
      </Grid>
      <Grid item xs={12} md={6} className={classes.formGrid}>
        <ClickAwayListener onClickAway={handleClickAway("business_name")}>
          <TextField className={classes.textFieldInput}
            required
            id="business_name-required"
            label="Razón Social"
            variant="outlined"
            size="small"
            value={stateProps.state.business_name}
            onChange={handleInputChangeWithFormat("business_name")}
            error={stateProps.errors.business_name !== ""}
            helperText={stateProps.errors.business_name}
            fullWidth
          />
        </ClickAwayListener>
      </Grid>
      <Grid item xs={12} md={6} className={classes.formGrid}>
        <FormControl
          fullWidth
          variant="outlined"
          margin="dense"
          required
          className={classes.formControl}
        >
          <InputLabel 
            ref={inputLabel}
            id="dte_emit-select-outlined-label"
            error={stateProps.errors.dte_emit !== ""}
          >
            Emites boleta y/o factura
          </InputLabel>
          <ClickAwayListener onClickAway={handleClickAway("dte_emit")}>
            <Select className={classes.textFieldInput}
              labelId="dte_emit-select-outlined-label"
              id="dte_emit-select-outlined"
              value={stateProps.state.dte_emit}
              onChange={handleInputChange("dte_emit")}
              error={stateProps.errors.dte_emit !== ""}
              labelWidth={labelWidth}
            >
              <MenuItem value="" disabled>
                <em>Elige una opción</em>
              </MenuItem>
              {AVAILABLE_DTE.map(dte => (
                <MenuItem key={dte} value={dte}>
                  {dte}
                </MenuItem>
              ))}
            </Select>
          </ClickAwayListener>
          {
            stateProps.errors.dte_emit !== ""
            ? <FormHelperText error>{stateProps.errors.dte_emit}</FormHelperText>
            : ""
          }
        </FormControl>
      </Grid>
      {stateProps.state.country === CHILE.value ? (
        <Grid item xs={12} md={6} className={classes.otherMarketplaceInput}>
          <ClickAwayListener onClickAway={handleClickAway("economic_activity")}>
            <Autocomplete
              multiple
              id="economic_activity-outlined"
              options={sii}
              size="small"
              getOptionLabel={option => option.label}
              onChange={(e, value) =>
                stateProps.handleSetState("economic_activity", SHOP_FORM_SECTION_NAME)(
                  value
                )
              }
              value={stateProps.state.economic_activity}
              filterSelectedOptions
              renderInput={params => (
                <TextField className={classes.textFieldInput}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <Search />
                        {params.InputProps.startAdornment}
                      </>
                    ),
                  }}
                  label="Giro de la empresa"
                  placeholder="Giro de la empresa"
                  error={stateProps.errors.economic_activity !== ""}
                  helperText={stateProps.errors.economic_activity}
                  required
                  fullWidth
                />
              )}
            />
          </ClickAwayListener>
        </Grid>
      ) : (
        <>
          <Grid item xs={12} md={6} className={classes.formGrid}>
            <FormControl
              fullWidth
              variant="outlined"
              margin="dense"
              required
              className={classes.formControl}
            >
              <InputLabel 
                ref={inputLabel}
                id="department-select-outlined-label"
                error={stateProps.errors.department !== ""}
              >
                Departamento
              </InputLabel>
              <Select className={classes.textFieldInput}
                labelId="department-select-outlined-label"
                id="department-select-outlined"
                value={stateProps.state.department}
                onChange={handleInputChange("department")}
                error={stateProps.errors.department !== ""}
                labelWidth={labelWidth}
              >
                <MenuItem value="" disabled>
                  <em>Elige una opción</em>
                </MenuItem>
                {PERU_REGIONS.map(dpto => (
                  dpto.administrativeDivisionFirst.map(dptoValue =>(
                    <MenuItem key={dptoValue.name} value={dptoValue.name}>
                      {dptoValue.name}
                    </MenuItem>
                  ))
                ))}
              </Select>
              {
                stateProps.errors.department !== ""
                ? <FormHelperText error>{stateProps.errors.department}</FormHelperText>
                : ""
              }
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} className={classes.formGrid}>
            <FormControl
              fullWidth
              variant="outlined"
              margin="dense"
              required
              className={classes.formControl}
            >
              <InputLabel 
                ref={inputLabel}
                id="province-select-outlined-label"
                error={stateProps.errors.province !== ""}
              >
                Provincia
              </InputLabel>
              <Select className={classes.textFieldInput}
                labelId="province-select-outlined-label"
                id="province-select-outlined"
                value={stateProps.state.province}
                disabled={stateProps.state.department===''}
                onChange={handleInputChange("province")}
                error={stateProps.errors.province !== ""}
                labelWidth={labelWidth}
              >
                <MenuItem value="" disabled>
                  <em>Elige una opción</em>
                </MenuItem>
                {PERU_REGIONS.map(dpto => (
                  dpto.administrativeDivisionFirst.map(dptoValue =>(
                    dptoValue.name === stateProps.state.department ? (
                      dptoValue.administrativeDivisionSecond.map(provValue => (
                        <MenuItem key={provValue.name} value={provValue.name}>
                          {provValue.name}
                        </MenuItem>
                      ))
                    ):('')
                  ))
                ))}
              </Select>
              {
                stateProps.errors.province !== ""
                ? <FormHelperText error>{stateProps.errors.province}</FormHelperText>
                : ""
              }
            </FormControl>
          </Grid>
          { NO_RESTRICTION_DEPARTMENTS.includes(stateProps.state.department) || stateProps.state.department==='' ? ('') : (
            <Grid item xs={12} md={12} className={classes.formGridTextTooltip}>
              <Tooltip 
                arrow
                className=''
                title={
                  <Typography variant='h4'>
                    {TOOLTIP_OWN_FLEET}
                  </Typography>
                }
                placement="left"
              >
                <Info style={{ color: '#5b73ba', marginTop: '15px' }}/>
              </Tooltip>
              <p>¿Dispones con flota propia para realizar el despacho de tus productos?</p>
              <RadioGroup className={classes.gridGroup} onChange={handleRadioButton}>
                <FormControlLabel
                  className={classes.label}
                  control={
                    <Radio
                      color="primary"
                      checked={checksStatus[YES_OWN_FLEET_ID]}
                      value={true}
                      name={OWN_FLEET_OPTION_NAME}
                      id={YES_OWN_FLEET_ID}
                    />
                  }
                  label={'Si'}
                />
                <FormControlLabel
                  className={classes.label}
                  control={
                    <Radio
                      color="primary"
                      checked={checksStatus[NO_OWN_FLEET_ID]}
                      value={false}
                      name={OWN_FLEET_OPTION_NAME}
                      id={NO_OWN_FLEET_ID}
                    />
                  }
                  label={'No'}
                />
              </RadioGroup>
            </Grid>
          )}
          <Grid item xs={12} md={6} className={classes.formGridTooltip}>
            <Tooltip 
              arrow
              className=''
              title={
                <Typography variant='h4'>
                  {TOOLTIP_AVERAGE_PRODUCTS}
                </Typography>
              }
              placement="left"
            >
              <Info style={{ color: '#5b73ba', marginTop: '7.5px' }}/>
            </Tooltip>
            <FormControl
              fullWidth
              variant="outlined"
              margin="dense"
              required
              className={classes.formControl}
            >
              <InputLabel 
                ref={inputLabel}
                id="quantity_products-select-outlined-label"
                error={stateProps.errors.quantity_products !== ""}
              >
                Cantidad promedio de productos
              </InputLabel>
              <ClickAwayListener onClickAway={handleClickAway("quantity_products")}>
                <Select className={classes.textFieldInput}
                  labelId="quantity_products-select-outlined-label"
                  id="quantity_products-select-outlined"
                  value={stateProps.state.quantity_products}
                  onChange={handleInputChange("quantity_products")}
                  error={stateProps.errors.quantity_products !== ""}
                  labelWidth={labelWidth}
                >
                  <MenuItem value="" disabled>
                    <em>Elige una opción</em>
                  </MenuItem>
                  {AVERAGE_PRODUCTS.map(avg => (
                    <MenuItem key={avg} value={avg}>
                      {avg}
                    </MenuItem>
                  ))}
                </Select>
              </ClickAwayListener>
              {
                stateProps.errors.quantity_products !== ""
                ? <FormHelperText error>{stateProps.errors.quantity_products}</FormHelperText>
                : ""
              }
            </FormControl>
          </Grid>
        </>
      )}
      <Grid item xs={12} md={6} className={classes.formGrid}>
        <FormControl
          fullWidth
          variant="outlined"
          margin="dense"
          required
          className={classes.formControl}
        >
          <InputLabel 
            ref={inputLabel}
            id="main_category-select-outlined-label"
            error={stateProps.errors.main_category !== ""}
          >
            Categoría principal
          </InputLabel>
          <ClickAwayListener onClickAway={handleClickAway("main_category")}>
            <Select className={classes.textFieldInput}
              labelId="main_category-select-outlined-label"
              id="main_category-select-outlined"
              value={stateProps.state.main_category}
              onChange={handleInputChange("main_category")}
              error={stateProps.errors.main_category !== ""}
              labelWidth={labelWidth}
            >
              <MenuItem value="" disabled>
                <em>Elige una opción</em>
              </MenuItem>
              {storeNewCategories.map(category => (
                <MenuItem key={category.value} value={category.value}>
                  {category.label}
                </MenuItem>
              ))}
            </Select>
          </ClickAwayListener>
          {
            stateProps.errors.main_category !== ""
            ? <FormHelperText error>{stateProps.errors.main_category}</FormHelperText>
            : ""
          }
        </FormControl>
      </Grid>
      {stateProps.state.country === CHILE.value ? ('') : (
        <Grid item xs={12} md={12} className={classes.formGridText}>
          <p>¿Eres parte de ASEP (Asociación de Emprendedores Perú)?</p>
          <RadioGroup className={classes.gridGroup} onChange={handleRadioButton}>
            <FormControlLabel
              className={classes.label}
              control={
                <Radio
                  color="primary"
                  checked={checksStatus[YES_ASEP_ID]}
                  value={true}
                  name={ASEP_OPTION_NAME}
                  id={YES_ASEP_ID}
                />
              }
              label={'Si'}
            />
            <FormControlLabel
              className={classes.label}
              control={
                <Radio
                  color="primary"
                  checked={checksStatus[NO_ASEP_ID]}
                  value={false}
                  name={ASEP_OPTION_NAME}
                  id={NO_ASEP_ID}
                />
              }
              label={'No'}
            />
          </RadioGroup>
        </Grid>
      )}
      <Dialog
        title={dialogState.title}
        type={dialogState.type}
        divider={dialogState.divider}
        noButton={dialogState.noButton}
        open={dialogState.open}
        maxWidth={dialogState.maxWidth}
        buttonLabels={{
          onCloseLabel: dialogState.buttonLabels.onCloseLabel,
          onSuccessLabel: dialogState.buttonLabels.onSuccessLabel
        }}
        actions={{
          onClose: dialogState.actions.onClose,
          onSuccess: dialogState.actions.onSuccess
        }}
        hasSecondaryButton={dialogState.hasSecondaryButton}
      >
        {dialogState.children}
      </Dialog>
    </Grid>
  )
}

ShopForm.propTypes = {
  stateProps: PropTypes.exact({
    state: PropTypes.exact({
      dte_emit: PropTypes.string,
      commercial_name: PropTypes.string.isRequired,
      business_name: PropTypes.string.isRequired,
      main_category: PropTypes.string.isRequired,
      economic_activity: PropTypes.array.isRequired,
      id_social_reason: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired,
      department: PropTypes.string,
      province: PropTypes.string,
      quantity_products: PropTypes.string,
      asep: PropTypes.bool,
      own_fleet: PropTypes.bool,
    }).isRequired,
    setState: PropTypes.func.isRequired,
    handleSetState: PropTypes.func.isRequired,
    errors: PropTypes.exact({
      dte_emit: PropTypes.string,
      commercial_name: PropTypes.string,
      business_name: PropTypes.string,
      main_category: PropTypes.string,
      economic_activity: PropTypes.string,
      id_social_reason: PropTypes.string,
      quantity_products: PropTypes.string,
      department: PropTypes.string,
      province: PropTypes.string,
      asep: PropTypes.bool,
      own_fleet: PropTypes.bool,
    }),
    onRestoreErrors: PropTypes.func,
  }).isRequired,
}

export default ShopForm
